import PropTypes from "prop-types";
import classNames from "classnames";
import { numberWithCommas } from "../utils";
import css from "../styles_web/RewardsBox.module.css";
import RewardsPopper from "./RewardsPopper";
import { getRewardColor } from "../utils/rewards";
import { useState, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  ExpiringPointIcon,
  ExpiringPointIconBox,
} from "../components/Rewards/Rewards.styled";
import { ASSETS_BASE_URL } from "../constants";
import Image from "../components/shared/Image";
import { useNavigate } from "react-router-dom";

const RewardsBox = ({
  mode,
  tier,
  tierLabel,
  isFirstTier,
  isLastTier,
  nextTier,
  nextTierLabel,
  nextTierSpend,
  tierProgressPercent,
  points,
  info,
  expiring,
  expiringPoints,
  onClosed,
}) => {
  const navigate = useNavigate();
  const rewardsRef = useRef();
  const [popperOpen, setPopperOpen] = useState(false);

  const openRewardsPopper = (e) => {
    if (e.target && rewardsRef?.current?.contains(e.target)) {
      setPopperOpen(!popperOpen);
    }
  };

  const closeRewardsPopper = () => {
    setPopperOpen(false);
  };

  const handleClose = (e) => {
    onClosed();
    navigate("/b2b/my-account/regen-rewards");
  };

  const getIcon = (tier) => {
    if (tier) {
      return (
        <Image
          className={classNames([css["tier-icon"]], [css[`tier-icon-${tier}`]])}
          src={`${ASSETS_BASE_URL}/image/website/content/checkout/${tier.toLowerCase()}.svg`}
          alt={`tier-${tier}`}
        />
      );
    }
    return (
      <Image
        className={classNames([css["tier-icon"]], [css["tier-icon-bronze"]])}
        src={`${ASSETS_BASE_URL}/image/website/content/checkout/bronze.svg`}
        alt="tier-bronze"
      />
    );
  };

  return (
    <div
      ref={rewardsRef}
      className={classNames([css["rewards-box"]], {
        [css["mobile"]]: mode === "mobile",
      })}
      onMouseEnter={openRewardsPopper}
      onMouseLeave={closeRewardsPopper}
    >
      <div className={css["tier"]}>
        <div className={css["tier-icon"]}>{getIcon(tier)}</div>
        <div
          className={css["tier-label"]}
          style={{ color: `var(${getRewardColor(tier)})` }}
        >
          {tierLabel}
        </div>
      </div>
      <div className={css["points"]}>
        <Box display="flex">
          <Typography variant="h5" className={css["points-label"]}>
            {numberWithCommas(points)}{" "}
            <span className={css["points-label-span"]}>Points</span>
          </Typography>
          {expiring && expiringPoints > 0 && (
            <div className={css["expiring-points-icon"]}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                ml={2}
              >
                <ExpiringPointIconBox
                  sx={{
                    height: "20px",
                    width: "20px",
                  }}
                >
                  <ExpiringPointIcon fontSize="0.8rem" />
                </ExpiringPointIconBox>
              </Box>
            </div>
          )}
        </Box>
        {!isFirstTier && info && (
          <>
            <div className={css["points-info"]}>{info}</div>
            {mode === "mobile" && (
              <div className={css["benefits"]} onClick={handleClose}>
                See benefits
              </div>
            )}
          </>
        )}
      </div>
      {mode !== "mobile" && (
        <RewardsPopper
          tier={tier}
          tierLabel={tierLabel}
          isFirstTier={isFirstTier}
          isLastTier={isLastTier}
          points={points}
          nextTier={nextTier}
          nextTierLabel={nextTierLabel}
          nextTierSpend={nextTierSpend}
          tierProgressPercent={tierProgressPercent}
          expiring={expiring}
          expiringPoints={expiringPoints}
          isOpen={popperOpen}
          onClosed={closeRewardsPopper}
          anchorEl={rewardsRef.current}
        ></RewardsPopper>
      )}
    </div>
  );
};

RewardsBox.propTypes = {
  mode: PropTypes.string,
  tier: PropTypes.string,
  tierLabel: PropTypes.string,
  isFirstTier: PropTypes.bool,
  isLastTier: PropTypes.bool,
  points: PropTypes.number,
  nextTier: PropTypes.string,
  nextTierLabel: PropTypes.string,
  nextTierSpend: PropTypes.number,
  tierProgressPercent: PropTypes.number,
  info: PropTypes.string,
  expiring: PropTypes.string,
  expiringPoints: PropTypes.number,
  onClosed: PropTypes.func,
};

export default RewardsBox;
